// extracted by mini-css-extract-plugin
export default {"ButtonPrimary":"ButtonPrimary_ButtonPrimary__XF2Iy"};